import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomerInfoLoadIfNormalUserGuard } from 'app/core/guards/customer-info-load-if-normal-user.guard';
import { DependencyTreeGuard } from 'app/core/guards/dependency-tree.guard';
import { AuthorizationGuard } from 'app/core/store/session/authorization/authorization.resolve';
import { InvoicesPageContainer } from './invoices-page-container/invoices-page-container.component';
import { GetDefinitionsGuard } from '../../core/store/definitions/definitions.resolve';

const routes: Routes = [
  {
    path: 'invoices',
    component: InvoicesPageContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [AuthorizationGuard, GetDefinitionsGuard, CustomerInfoLoadIfNormalUserGuard],
      authorization: 'INVOICES.ACCESS',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InvoicesRoutingModule {}
